import {
    allFetch
} from "../Domain";

/**
 * @description 訂單交車修改
 */
export const PDIOrder = (() => {
    /**
     * @description 訂單交車修改 
     * @param {*} pdi_order_id PDI訂單系統編號
     * @param {*} predict_delivery_date 預計交車日期
     * @param {*} custom_date 自訂日期
     * @returns res
     */
    const PDIOrderDeliveryUpdate = async function (obj = {
        pdi_order_id: '',
        predict_delivery_date: '',
        custom_date: ''
    }) {
        return await allFetch('PDIOrder/PDIOrderDeliveryUpdate', obj);
    }

    /**
     * @description 訂單交車確認 
     * @returns res
     */
    const PDIOrderDeliveryCheck = async function (obj = {
        pdi_order_id: '',
        delivery_date: ''
    }) {
        return await allFetch('PDIOrder/PDIOrderDeliveryCheck', obj);
    }

    /**
     * @description 訂單交車確認取消 
     * @returns res
     */
    const PDIOrderDeliveryCancel = async function (obj = {
        pdi_order_id: ''
    }) {
        return await allFetch('PDIOrder/PDIOrderDeliveryCancel', obj);
    }

    /**
     * @description 訂單交車確認取消 
     * @returns res
     */
    const PDIOrderSearch = async function (obj = {
        outer_order_number: '',
        outer_order_processes: [],
        custody_user_id: '',
        custody_username: '',
        licensed_date_start: '',
        licensed_date_end: '',
        license_plate: '',
        delivery_date_start: '',
        delivery_date_end: '',
        cs_id: '',
        car_type: "",
        SIDO_no: '',
        has_pdi_procedure: "",
        contract_name: "",
        predict_delivery_date_start: "",
        predict_delivery_date_end: "",
        custom_date_start: '',
        custom_date_end: '',
        note: "",
        page: 0,
        num_per_page: 10,
    }) {
        return await allFetch('PDIOrder/PDIOrderSearch', obj);
    }


    /**
     * @description 訂單細項 
     * @returns res
     */
    const PDIOrderDetail = async function (obj = {
        pdi_order_id: ""
    }) {
        return await allFetch('PDIOrder/PDIOrderDetail', obj);
    }

    return {
        PDIOrderDeliveryUpdate,
        PDIOrderDeliveryCheck,
        PDIOrderDeliveryCancel,
        PDIOrderSearch,
        PDIOrderDetail
    };
})()